import { render } from "./home-view-component.vue?vue&type=template&id=408506ba&scoped=true&ts=true"
import script from "./home-view-component.vue?vue&type=script&lang=ts"
export * from "./home-view-component.vue?vue&type=script&lang=ts"

import "./home-view-component.vue?vue&type=style&index=0&id=408506ba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408506ba"]])

export default __exports__